// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-c3fb812c]:export {\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.createPost-container .createPost-main-container[data-v-c3fb812c] {\n  padding: 20px;\n}\n.card-header[data-v-c3fb812c] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.form-label[data-v-c3fb812c] {\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: #606266;\n}", ""]);
// Exports
module.exports = exports;
